.headline { display: flex; align-items: center; gap: 16px; margin: 0; font-family: var(--font-cond); font-weight: 900; text-transform: uppercase; color: var(--ink); line-height: 1; }
.headline[data-size='page'], .headline[data-size='compact'] { font-size: 92px; letter-spacing: -4px; }
.headline[data-size='onboarding'] { font-size: clamp(64px, 11vw, 110px); letter-spacing: -5px; line-height: 0.88; gap: 18px; }
/* Only the sign-in brand panel uses hero; it is min(760px, 52.8vw) wide with 56px side padding. */
.headline[data-size='hero'] { flex-direction: column; align-items: flex-start; gap: 0; font-size: min(150px, calc((52.8vw - 112px) / 4)); letter-spacing: -0.04em; line-height: 0.88; color: var(--paper); }
.second { color: var(--hot); }
.headline[data-size='hero'] .second { color: var(--pink); }

@media (max-width: 1023px) {
  .headline[data-size='hero'] { font-size: 110px; }
}

@media (max-width: 639px) {
  .headline { display: block; }
  .headline > span { display: block; }
  .headline[data-size='page'], .headline[data-size='compact'] { font-size: 60px; letter-spacing: -2.5px; line-height: 0.9; }
  .headline[data-size='compact'] { font-size: 56px; }
  .headline[data-size='onboarding'] { font-size: 64px; letter-spacing: -2.5px; }
  .headline[data-size='hero'] { font-size: 76px; letter-spacing: -3px; }
}
